export default __webpack_public_path__ + "static/show-selected-labels-in-search-buyer-view-54813fc42326045dcce71cd487af2c20.png";